import React from 'react';

export default {
  HU: {
    title: 'Időmérleg 2010',
    colors: 'Színezés',
    bySex: 'nemek szerint',
    byTarget: 'tevékenység szerint',
    KSH: 'KSH',
    methodology: 'Módszertan',
    close: 'Bezár',
    countries: [
      { "code": "AT", "name": "Ausztria" },
      { "code": "BE", "name": "Belgium" },
      { "code": "UK", "name": "Egyesült Királyság" },
      { "code": "EE", "name": "Észtország" },
      { "code": "FI", "name": "Finnország" },
      { "code": "FR", "name": "Franciaország" },
      { "code": "EL", "name": "Görögország" },
      { "code": "NL", "name": "Hollandia" },
      { "code": "PL", "name": "Lengyelország" },
      { "code": "HU", "name": "Magyarország" },
      { "code": "DE", "name": "Németország" },
      { "code": "NO", "name": "Norvégia" },
      { "code": "IT", "name": "Olaszország" },
      { "code": "RO", "name": "Románia" },
      { "code": "ES", "name": "Spanyolország" },
      { "code": "RS", "name": "Szerbia" },
      { "code": "TR", "name": "Törökország" }
    ],
    activities: [
      "Alvás",
      "Étkezés",
      "Fizetett munka",
      "Tanulás",
      "Személyes szükségletek",
      "Vásárlás",
      "Házimunka",
      "Gondoskodás",
      "Más háztartás számára végzett munka",
      "Önkéntes munka",
      "Vallásgyakorlás",
      "Szabadidő",
      "Tévénézés és rádiózás",
      "Sport",
      "Utazás",
      "Egyéb"
    ],
    info: <div>
      <h3>Módszertan</h3>
      <p>Az adatok forrása egy előre meghatározott korcsoportra vonatkozó reprezentatív lakossági minta. A kérdezőbiztosok által végrehajtott, a megkérdezettek önkéntes együttműködésén alapuló kérdőíves adatfelvételre általában 7-10 évenként kerül sor. </p>
      <p>A <i>KSH adatgyűjtéseiben</i> a felvételre kijelölt, háztartásonkénti egy személy előre meghatározott napjának teljes napi időfelhasználásáról szóló időmérlegnaplót kérdezőbiztos tölti ki <b>a kijelölt napot követő napon</b>, ún. tegnapinterjú keretében.</p>
      <p>Az <i>Eurostat által koordinált felvételek</i> többségében a háztartás valamennyi megfelelő korú személyéről azonos napra vonatkozó önkitöltéses kérdőívekkel gyűjtik be az adatokat.</p>
      <p>További információk: <a  rel="noopener noreferrer" target="_blank" href="http://www.ksh.hu/docs/hun/xftp/idoszaki/idomerleg/idomerleg0910.pdf">Időmérleg 2009/2010</a>, <a href="http://www.ksh.hu/apps/meta.objektum?p_lang=HU&p_menu_id=120&p_ot_id=100&p_obj_id=ZFI&p_session_id=18604054" target="_blank" rel="noopener noreferrer">metaadatok</a>.</p>
      <p>Az ábra <a href="http://flowingdata.com/2015/12/15/a-day-in-the-life-of-americans/" target="_blank" rel="noopener noreferrer">Nathan Yau</a> ötlete nyomán, az Eurostat Grant-projekt keretében 17 ország adatállományának módszertanilag harmonizált időmérleg-felvétele adatainak felhasználásával készült.</p>
    </div>
  },
  EN: {
    title: 'Time use 2010',
    colors: 'Colors by',
    bySex: 'sex',
    byTarget: 'activity',
    KSH: 'HCSO',
    methodology: 'Methodology',
    close: 'Close',
    countries: [
      { "code": "AT", "name": "Austria" },
      { "code": "BE", "name": "Belgium" },
      { "code": "EE", "name": "Estonia" },
      { "code": "FI", "name": "Finland" },
      { "code": "FR", "name": "France" },
      { "code": "DE", "name": "Germany" },
      { "code": "EL", "name": "Greece" },
      { "code": "HU", "name": "Hungary" },
      { "code": "IT", "name": "Italy" },
      { "code": "NL", "name": "The Netherlands"},
      { "code": "NO", "name": "Norway" },
      { "code": "PL", "name": "Poland" },
      { "code": "RO", "name": "Romania" },
      { "code": "RS", "name": "Serbia" },
      { "code": "ES", "name": "Spain" },
      { "code": "TR", "name": "Turkey" },
      { "code": "UK", "name": "United Kingdom" }
    ],
    activities: [
      "Sleeping",
      "Eating & Drinking",
      "Work",
      "Education",
      "Personal Care",
      "Shopping",
      "Housework",
      "Household Care",
      "Work for other households",
      "Volunteering",
      "Religion",
      "Leisure",
      "Watching TV & radio",
      "Sports",
      "Traveling",
      "Other"],
    info: <div>
      <h3>Methodology</h3>
      <p>The source of data is a representative household sample of an age-group defined in advance. The questionnaire survey is performed by interviewers generally in every 7-10 years on the basis of the voluntary cooperation of respondents.</p>
      <p><i>In the data collections of HCSO</i>, an interviewer fills in the time-use diary about the entire daily time use on one pre-defined day of one person designated to be surveyed per household, in the framework of a "yesterday interview" <b>on the day following the designated day</b>.</p>
      <p>In the majority of <i>data recordings coordinated by Eurostat</i>, the data are collected by means of self-completed questionnaires for the same day by all household members of the appropriate age.</p>
      <p>Further information: <a href="http://www.ksh.hu/apps/meta.objektum?p_lang=EN&p_menu_id=120&p_ot_id=100&p_obj_id=ZFI&p_session_id=18604054" target="_blank"  rel="noopener noreferrer">metadata</a>.</p>
      <p>The chart was prepared based on an idea by <a href="http://flowingdata.com/2015/12/15/a-day-in-the-life-of-americans/" target="_blank"  rel="noopener noreferrer">Nathan Yau</a>, using the data of 17 countries’ time use surveys methodologically harmonised in the framework of a Eurostat Grant project.</p>
    </div>
  }
}




// WEBPACK FOOTER //
// ./src/text.js